import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the TimeAutoFormatPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'timeAutoFormat',
})
export class TimeAutoFormatPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return value.toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/pipes/time-auto-format/time-auto-format.ts